import React from 'react';
import { FadeIn } from './FadeIn';
export function Personal() {
  return <section className="py-20 md:py-32 px-6" data-id="element-63" data-mp="1j5iodhnej4qy">
      <div className="max-w-6xl mx-auto" data-id="element-64" data-mp="1j4qqu1a8uwy1">
        <FadeIn className="mb-12 md:mb-20" data-id="element-65" data-mp="1j3pdfq5r9yd5">
          <div className="flex items-center gap-4 max-w-reading mx-auto" data-id="element-66" data-mp="1e7h5awpz75fh">
            <div className="h-px w-12 bg-amber/30" data-id="element-67" data-mp="1a53wfzfxmreh" />
            <h2 className="font-playfair text-3xl md:text-4xl text-charcoal italic" data-id="element-68" data-mp="1a6ova19a4wi5">
              Off the Clock
            </h2>
            <div className="h-px flex-grow bg-amber/30" data-id="element-69" data-mp="21w0cf8xahc5z" />
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-70" data-mp="21u75rtmoerxz">
          {/* Photo */}
          <FadeIn direction="right" className="lg:col-span-5" data-id="element-71" data-mp="1svbva5clmvov">
            <div className="relative" data-id="element-72" data-mp="1sv280pixv2mv">
              {/* Decorative offset frame */}
              <div className="absolute -inset-3 border border-amber/30 rounded-sm hidden md:block" data-id="element-73" data-mp="mguifjoyn7xw" />
              <div className="relative aspect-[4/3] sm:aspect-[4/5] overflow-hidden rounded-sm bg-gradient-to-br from-amber-light via-cream-dark to-sage-light shadow-lg" data-id="element-74" data-mp="helnihsj1vt5">
                {/* Replace with your actual photo */}
                <div className="w-full h-full mix-blend-overlay opacity-50 bg-[url('https://images.unsplash.com/photo-1535131749006-b7f58c99034b?q=80&w=1200&auto=format&fit=crop')] bg-cover bg-center" data-id="element-75" data-mp="wbfnhq2d3g9j" />
                <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-charcoal/40 to-transparent" data-id="element-76" data-mp="neybylq35gd9">
                  <p className="font-playfair italic text-cream text-sm" data-id="element-77" data-mp="denxyyw884x1">
                    Out on the course
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Text */}
          <div className="lg:col-span-7 space-y-6 text-base md:text-lg text-charcoal/80 leading-relaxed font-light" data-id="element-78" data-mp="3pxmmwfar4ld">
            <FadeIn delay={0.1} data-id="element-79" data-mp="3lvj0gd943nal">
              <p className="font-playfair text-xl md:text-3xl text-charcoal italic leading-snug mb-6 md:mb-8" data-id="element-80" data-mp="3qtu8cifujnq6">
                Bay Area kid, lifelong golfer, and a sucker for a good history
                book.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-81" data-mp="1rm3syuc1x01e">
              <p data-id="element-82" data-mp="1rl2fykbh63h1">
                I grew up in the Bay Area and honestly couldn't have asked for a
                better place to come from. It shaped a lot of how I think — open
                to new ideas, comfortable around different kinds of people, and
                always a little restless to keep learning.
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-83" data-mp="2bc7glcmhsgj8">
              <p data-id="element-84" data-mp="2b8rx7xlsclc0">
                I picked up golf when I was 10 and never put it down. It's the
                one thing I've stuck with my whole life, and it's quietly taught
                me more than I realized at the time — patience, how to handle a
                bad break, and the fact that small adjustments usually matter
                more than big ones. When I'm not on the course, I'm probably
                reading about history or going down some economics rabbit hole.
                Both are basically about why people do what they do, which I
                think is the most interesting question there is.
              </p>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}